export default function HowTrainingGoes() {
  const stages = [
    { number: '01', title: 'Диагностика', desc: 'Анализ текущих показателей, воронки продаж, конверсии, среднего чека. Аудит звонков и переписок.', duration: '3–5 дней' },
    { number: '02', title: 'Интервью', desc: 'Беседы с руководителем отдела, ключевыми менеджерами. Выявление болевых точек и зон роста.', duration: '1–2 дня' },
    { number: '03', title: 'Подготовка', desc: 'Разработка индивидуальной программы обучения. Подготовка кейсов на материале компании.', duration: '5–7 дней' },
    { number: '04', title: 'Обучение', desc: 'Практический тренинг: 80% практики, ролевые игры, отработка навыков, разбор реальных ситуаций.', duration: '1–3 дня' },
    { number: '05', title: 'Практика', desc: 'Применение навыков в работе. Домашние задания, самостоятельная отработка, чек-листы.', duration: '2–4 недели' },
    { number: '06', title: 'Внедрение', desc: 'Интеграция новых инструментов в ежедневную работу. Корректировка скриптов, регламентов, KPI.', duration: '1–2 месяца' },
    { number: '07', title: 'Сопровождение', desc: 'Регулярные встречи, выборочный аудит звонков, ответы на вопросы, корректировка программы.', duration: '1–6 месяцев' },
  ];

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Как проходит <strong>обучение отдела продаж</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Семь этапов — от диагностики до сопровождения. Каждый этап последовательно выводит команду на новый уровень эффективности.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          {/* Vertical line */}
          <div className="absolute left-[27px] md:left-[35px] top-4 bottom-4 w-0.5 bg-teal-200 hidden sm:block"></div>

          <div className="space-y-0">
            {stages.map((stage, i) => (
              <div key={i} className="flex gap-5 md:gap-8 pb-8 md:pb-10">
                {/* Number circle */}
                <div className="relative z-10 flex-shrink-0">
                  <div className="w-14 h-14 md:w-[70px] md:h-[70px] bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-sm md:text-lg shadow-lg">
                    {stage.number}
                  </div>
                </div>

                {/* Content */}
                <div className="bg-white rounded-xl p-5 md:p-6 flex-1 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2">
                    <h3 className="text-lg md:text-xl font-bold text-gray-900">{stage.title}</h3>
                    <span className="text-xs font-semibold text-teal-600 bg-teal-50 px-3 py-1 rounded-full whitespace-nowrap">{stage.duration}</span>
                  </div>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">{stage.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Начать с диагностики
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}